module.exports = __webpack_public_path__ + "static/img/bannerindex2.7c4eae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/bannerindex2.jpg
// module id = 8VVz
// module chunks = 9